import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CrudFilters');
const CrudFilters = /*#__PURE__*/memo(_ref => {
  let {
    entity,
    filtersComponent,
    filtersAddButtonSchema,
    forceBIFiltersProps
  } = _ref;
  const classes = useStyles();
  const Filters = filtersComponent;
  const filtersProps = useMemo(() => _objectSpread({
    entity,
    filtersAddButtonSchema,
    avoidQuickFilters: true,
    forceSelectAllTypes: true
  }, forceBIFiltersProps), [entity, filtersAddButtonSchema, forceBIFiltersProps]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Filters, _extends({
    isFullWidth: true,
    useDrawer: false,
    useHeader: false
  }, filtersProps, {
    useGeneralSections: false,
    useSectionsTitle: true
  })));
});
export default CrudFilters;